import {Component} from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

export default class TitleInterests extends Component {
  static propTypes = {
    className: PropTypes.string,
    interests: PropTypes.array,
  };

  render() {
    const {className, interests} = this.props;
    const classNames = ['title-interests', className].join(' ').trim();

    return (
      <div className={classNames}>
        <Grid>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              <strong>Interests</strong>
            </Grid.Column>
            <Grid.Column width={12}>
              {interests.map((interest) => (
                <p>{interest.description ? interest.description : '-'}</p>))
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}